<template lang="pug">
.k-icon-hamburger(@click="$emit('input', !value)")
  .k-icon-hamburger__burger(:class="classes")
    span
    span
    span
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    classes () {
      return {
        'k-icon-hamburger__burger--opened': this.value,
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.k-icon-hamburger {
  cursor: pointer;
  height: 30px;
  position: relative;
  width: 30px;

  &__burger {
    height: 30px;
    pointer-events: none;
    width: 30px;

    span {
      background: var(--v-brand-dark-blue-base);
      border-radius: 5px;
      display: block;
      height: 3px;
      left: 0;
      position: absolute;
      top: 12px;
      transition: .2s;
      width: 100%;

      &:first-child {
        top: 0;
      }

      &:last-child {
        top: 24px;
      }
    }

    &:hover {
      cursor: pointer;
    }

    &--opened {
      span {
        background: white !important;
        opacity: 0;
        top: 12px !important;

        &:first-child {
          opacity: 1;
          transform: rotate(45deg);
        }

        &:nth-child(2) {
          width: 0;
        }

        &:last-child {
          opacity: 1;
          transform: rotate(-45deg);
        }
      }
    }
  }
}
</style>
